import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const CNModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6', 'Module 7'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'Data Communications and Networking: A Communications Model – Data Communications Evolution of network, Requirements, Applications', path: '/cn-m1-s1' },
      { name: 'Network Topology', path: '/cn-m1-s2' },
      { name: 'Protocols and Standards', path: '/cn-m1-s3' },
      { name: 'Network Models (OSI, TCP/IP)', path: '/cn-m1-s4' }
    ],
    'Module 2': [
      { name: 'Circuit and Packet Switching', path: '/cn-m2-s1' },
      { name: 'Networking Parameters (Transmission Impairment, Data Rate and Performance)', path: '/cn-m2-s2' }
    ],
    'Module 3': [
      { name: 'Error Detection and Correction – Hamming Code, CRC, Checksum', path: '/cn-m3-s1' },
      { name: 'Flow control mechanism – Sliding Window Protocol - GoBack - N - Selective Repeat', path: '/cn-m3-s2' },
      { name: 'Multiple access Aloha - Slotted Aloha', path: '/cn-m3-s3' },
      { name: 'CSMA, CSMA/CD', path: '/cn-m3-s4' },
      { name: 'IEEE Standards(IEEE802.3 (Ethernet), IEEE802.11(WLAN))- RFID- Bluetooth Standards', path: '/cn-m3-s5' }
    ],
    'Module 4': [
      { name: 'IPv4 Address Space – Notations – Classful Addressing – Classless Addressing', path: '/cn-m4-s1' },
      { name: 'Network Address Translation', path: '/cn-m4-s2' },
      { name: 'IPv6 Address Structure – IPv4 and IPv6 header format', path: '/cn-m4-s3' }
    ],
    'Module 5': [
      { name: 'Routing - Link State and Distance Vector Routing Protocols - Implementation - Performance Analysis - Packet Tracer', path: '/cn-m5-s1' }
    ],
    'Module 6': [
      { name: 'TCP and UDP', path: '/cn-m6-s1' },
      { name: 'Congestion Control, Traffic Management, QoS', path: '/cn-m6-s2' }
    ],
    'Module 7': [
      { name: 'Application Layer, DNS, FTP, HTTP, SMTP, SNMP', path: '/cn-m7-s1' }
    ],
  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Computer Networks</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module] && subtopicsData[module].length > 0 ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-CNModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Coming Soon...</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CNModules;
